import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})
export class ConfirmationPopupComponent implements OnInit {

  @Input() details: any = {
    message: '',
    message1: '',
    title: '',
    action: 'Yes, Delete it!'
  };
  //@Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() close = new EventEmitter<any>();

  @Input() useReasonDropdown:boolean=false;
  @Input() ReasonModule:any;
  ReasonValue:any;
  Reason: any = {
    lable: 'Cancellation Reason',
    formControlName: 'Reason',
    dataField: 'Reason',
    isRequired: true,
    placeholder: 'Select Reason',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  constructor(
    private orderService: OrdersService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
  }

  Cancel() {
    this.close.emit()
  }

  confirm() {
    if (this.useReasonDropdown) {
      if (!this.ReasonValue) {
        this.toastr.warning("Please select reason", "warning");
        return;
      }
      
      this.close.emit({
        confirmed: true,
        reasonValue: this.ReasonValue
      });
    } else {
      this.close.emit(true);
    }
  }

  getChangedValue(value:any, data:any){
    if(value){
      this.ReasonValue = value.value;
    } else {
      this.ReasonValue = null;
    }
  }

  GetReasonList(value:any, isScrollDown = false) {
    this.Reason.isSearch = true;
    let type = this.ReasonModule;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Reason.dropdownList.length / 20) + 1;
    }
    this.orderService.ReasonSelect2(value, pageNo, type).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Reason.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Reason.dropdownList);
        this.Reason = { ...this.Reason, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Reason = { ...this.Reason, dropdownList: [...dropdownList] });
      this.Reason.isSearch = false;
    }).catch(error => {
      this.Reason.isSearch = false;
    })
  }

}
